import React, { useState, Component } from 'react';
import { Search, Bell } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function Header() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };
  return <header className="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-6" data-id="element-69">
      <div className="w-96" data-id="element-70">
        <form onSubmit={handleSearch} data-id="element-71">
          <div className="relative" data-id="element-72">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-73">
              <Search className="h-4 w-4 text-gray-400" data-id="element-74" />
            </div>
            <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search stores, orders, or customers..." className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-gray-50 placeholder-gray-500 focus:outline-none focus:bg-white focus:ring-1 focus:ring-red-500 focus:border-red-500 sm:text-sm transition duration-150 ease-in-out" data-id="element-75" />
          </div>
        </form>
      </div>
      <div className="flex items-center space-x-4" data-id="element-76">
        <button className="p-2 rounded-full text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-red-500" data-id="element-77">
          <span className="sr-only" data-id="element-78">View notifications</span>
          <Bell className="h-5 w-5" data-id="element-79" />
        </button>
      </div>
    </header>;
}